
import { useState } from 'react';

export default function ContactForm() {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    zip: '',
    message: '',
    consent: false,
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (submitting || submitted) return;
    if (form.message.length > 500) return;
    setSubmitting(true);
    setError('');

    const body = new URLSearchParams();
    body.append('name', form.name);
    body.append('phone', form.phone);
    body.append('zip', form.zip);
    body.append('message', form.message);
    body.append('consent', form.consent ? 'Yes' : 'No');

    try {
      const res = await fetch('https://readdy.ai/api/form/d6fkafgr225iqdhs0bn0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setSubmitted(true);
      } else {
        setError('Submission failed. Please try again.');
      }
    } catch (err) {
      setError('Something went wrong. Please check your connection and try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="bg-[#f5f7fa] py-12">
      <div className="max-w-2xl mx-auto px-4">
        {submitted ? (
          <div className="flex items-center justify-center w-full aspect-square bg-[#2E7DD1] rounded-xl">
            <p className="text-white text-xl font-bold text-center px-6 leading-relaxed">
              Thank you for your submission. We will see you soon!
            </p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className="bg-white rounded-xl p-6 shadow-lg space-y-4 border border-gray-100"
            data-readdy-form
            id="contact-form"
          >
            <div className="grid grid-cols-3 gap-3">
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                placeholder="Name"
                className="px-3 py-2.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#1E88E5] bg-white"
              />
              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                placeholder="Phone Number"
                required
                pattern="[0-9()#&+*\-=. ]+"
                className="px-3 py-2.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#1E88E5] bg-white"
              />
              <input
                type="text"
                name="zip"
                value={form.zip}
                onChange={(e) => setForm({ ...form, zip: e.target.value })}
                placeholder="ZIP"
                className="px-3 py-2.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#1E88E5] bg-white"
              />
            </div>
            <textarea
              name="message"
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              placeholder="Tell Us How Can We Help You?"
              required
              maxLength={500}
              rows={3}
              className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#1E88E5] bg-white resize-none"
            />

            <label className="flex items-start gap-2 cursor-pointer">
              <input
                type="checkbox"
                name="consent"
                checked={form.consent}
                onChange={(e) => setForm({ ...form, consent: e.target.checked })}
                required
                className="w-4 h-4 rounded border-gray-400 text-[#1E88E5] focus:ring-[#1E88E5] mt-0.5"
              />
              <span className="text-xs text-gray-500">
                By submitting this form, you consent to receive emails, calls, or SMS messages from Sunshine Air Pros.
              </span>
            </label>

            {error && (
              <div className="bg-red-100 border border-red-400 text-red-800 px-4 py-3 rounded-lg text-sm font-medium flex items-center gap-2">
                <i className="ri-error-warning-fill text-base"></i>
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-[#2E7DD1] hover:bg-[#3B8FE8] text-white font-bold py-3 px-6 rounded-lg transition-colors whitespace-nowrap text-sm cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {submitting ? 'Sending...' : 'Send'}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
